/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import ScheduleLiveConsultation from '@brands/Dashboard/Dashboard/DashboardModals/ScheduleLiveConsultation';
import { convertDateFormat } from '@brands/Dashboard/MyProfile/Patient/utils/utilsFunctions';
import { SelectedAppointment } from '@brands/Dashboard/PatientForms/PatientForm/utils/types';
import CareAdvisorProfileCardModal from '@brands/Dashboard/ProfileCards/CareAdvisor/ProfileCards';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { rescheduleCase, RescheduleCasePayload } from '@brands/services/cases/rescheduleCase';
import { CaseType, ICase } from '@brands/services/cases/types/ICase';
import { getPricings, Pricings } from '@brands/services/identity/getPricings';
import { getUserAvatar } from '@brands/services/identity/getUserAvatar';
import { Insurance, UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectCurrentPatientState } from '@brands/store/selectors/currentPatientState';
import { selectOrganizationPrices } from '@brands/store/selectors/organizationPrices';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setForm } from '@brands/store/slices/patientFormSlice';
import { displayErrorDetails } from '@brands/Utils/displayError';
import { needsPayment } from '@brands/Utils/needsPayment';
import { isEndUserPatientRole } from '@brands/Utils/reviewProfileBasePath';
import { Button } from '@mui/material';
import Moment from 'moment';
import moment from 'moment-timezone';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FaChevronLeft } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { MultiValue } from 'react-select';
import { toast } from 'react-toastify';

import Container from '../../../../Components/Container/Container';
import { isIntakePaymentQuestionComplete } from '../../../../Utils/isIntakePaymentQuestionComplete';
import useAvailableCareAdvisorsNew from '../../../../hooks/useAvailableCareAdvisorsNew';
import useDebounce from '../../../../hooks/useDebounce';
import { useAppSelector } from '../../../../hooks/useReduxHook';
import useWindowSize from '../../../../hooks/useWindowSize';
import { listAllLanguages } from '../../../../services/identity/listAllLanguages';
import { IListAvailableCareAdvisorParams } from '../../../../services/identity/listAvailableCareAdvisorsDate';
import { Option, OptionLanguage } from '../../../../Utils/selectOptions';
import styles from './styles.module.scss';
import LanguageMultiSelect from './utils/LanguageMultiSelect';
import { formatTime } from './utils/utils';

const SelectCareAdvisor = (): JSX.Element => {
  const { state } = useLocation();
  const [rescheduleSuccessModal, setRescheduleSuccessModal] = useState<{
    openModal: boolean;
    updatedCase: ICase | null;
  }>({
    openModal: false,
    updatedCase: null,
  });
  const backPath = sessionStorage.getItem('lastNonSelectCAPagePath') || '/';
  const { userInfo } = useAppSelector(selectAuth);
  const dispatch = useDispatch();
  const { currentOrganizationPrices } = useAppSelector(selectOrganizationPrices);
  const [searchParams] = useSearchParams();
  const { values, selectedPatient } = useAppSelector(selectPatientForm);
  const organizationPrices = useAppSelector(selectOrganizationPrices);
  const RescheduleCase = state?.RescheduleCase ? state.RescheduleCase : searchParams.get('reschedule') || null;
  const selectedInsuranceId = (values?.find((item: any) => item.form_question_id === 19)?.value
    .dataWithUpdatedInsurance as Insurance)
    ? (values?.find((item: any) => item.form_question_id === 19)?.value.dataWithUpdatedInsurance as Insurance)
        .insurance_membership?.insurance_carrier_id
    : '';
  const screenSize = useWindowSize();
  const navigate = useNavigate();
  const roleNavigate = useRoleNavigate();
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const [languageOptions, setLanguageOptions] = useState<OptionLanguage[]>([]);
  const [languageFilter, setLanguageFilter] = useState<MultiValue<Option>>([{ label: 'English', value: 'en', id: 1 }]);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [providerProfileCardModal, setCareAdvisorProfileCardModal] = useState<boolean>(false);
  const [providerParticipant, setCareAdvisorParticipant] = useState<any>(null);
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<SelectedAppointment>({
    selectedDate: '',
    selectedTimeSlot: '',
    selectedDateTime: '',
    selectedCareAdvisorId: undefined,
  });
  const observer = useRef<IntersectionObserver>();
  const lastCareAdvisorItemRef = useRef<HTMLTableRowElement>(null);
  const currentState: string = useAppSelector(selectCurrentPatientState);

  const RescheduleCaseSelectedCarrierId = state?.RescheduleCaseSelectedCarrierId || null;
  const patient_current_state = state?.patient_current_state
    ? state?.patient_current_state
    : searchParams.get('case_state') || null;

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const isAdmin =
    userInfo.role.name === UserRoleName.Admin ||
    userInfo.role.name === UserRoleName.SuperAdmin ||
    userInfo.role.name === UserRoleName.OrganizationAdmin;

  /** Staff case-creation only: skip re-sending to payment when Q19 already saved (patient flow unchanged). */
  const isStaffPatientFlow =
    !isEndUserPatientRole(userInfo.role.name) && (isAdmin || userInfo.role.name === UserRoleName.Collector);

  const licenseState = useMemo(() => {
    if (RescheduleCase && patient_current_state) {
      return patient_current_state;
    }
    if (isAdmin) {
      return currentPatient?.id ? currentState[currentPatient.id] || '' : '';
    }
    return currentState[userInfo.id] || '';
  }, [RescheduleCase, patient_current_state, isAdmin, currentState, currentPatient?.id, userInfo.id]);

  const carrierId = useMemo(() => {
    if (selectedInsuranceId !== '' && selectedInsuranceId !== undefined) {
      return selectedInsuranceId;
    }
    if (RescheduleCase && RescheduleCaseSelectedCarrierId) {
      return RescheduleCaseSelectedCarrierId;
    }
    return undefined;
  }, [selectedInsuranceId, RescheduleCase, RescheduleCaseSelectedCarrierId]);

  const caseType = useMemo(() => {
    return (
      (RescheduleCase
        ? state.caseType
        : (values.find((item) => item.form_question_id === 20)?.value.caseType as string)) ||
      CaseType.video_call_scheduled
    );
  }, [RescheduleCase, state, values]);

  const params = useMemo<IListAvailableCareAdvisorParams>(
    () => ({
      date: moment().format('YYYY-MM-DD'),
      tz: timezone,
      license_states: [licenseState],
      synchronous: true,
      ...(carrierId ? { carrier_id: carrierId } : {}),
      out_of_network: true,
      patient_id: selectedPatient?.value,
      ...(caseType === CaseType.oral_health_coaching ? { case_type: caseType } : {}),
      ...(languageFilter.length > 0 ? { language: languageFilter.map((item) => item.label) } : {}),
    }),
    [timezone, licenseState, carrierId, selectedPatient, caseType, languageFilter],
  );

  const debouncedParams = useDebounce(params, 500);

  const { providers, loadNextPage, dataLoading, refreshCareAdvisors } = useAvailableCareAdvisorsNew(
    caseType === CaseType.oral_health_coaching ? 'care_advisors' : 'providers',
    debouncedParams,
  );

  const loadMore = (): void => {
    setIsLoading(true);
    loadNextPage().then(() => {
      setIsLoading(false);
    });
  };

  const handleIntersection = (entries: IntersectionObserverEntry[]): void => {
    const lastItem = entries[0];
    if (lastItem.isIntersecting && !isLoading) {
      loadMore();
    }
  };

  useEffect(() => {
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(handleIntersection);
    if (lastCareAdvisorItemRef.current) observer.current.observe(lastCareAdvisorItemRef.current);
  }, [providers]);

  const sortedCareAdvisorsWithTimeSlots = useMemo(() => {
    let nextAvailableSet = false;
    let nearestStartTimeIndex = -1;
    let nearestStartTimeDiff = Infinity;

    // Step 1: Sort providers by the number of `sync_time_slots` (from most to least)
    const sortedCareAdvisors = [...providers].sort((a, b) => b.sync_time_slots.length - a.sync_time_slots.length);

    // Step 2: Find the provider with the nearest future time slot
    sortedCareAdvisors.forEach((provider, index) => {
      if (provider.sync_time_slots.length > 0) {
        const firstSlotStartTime = provider.sync_time_slots[0]; // Earliest slot of the provider
        const startTimeDiff = moment(firstSlotStartTime).diff(moment());

        if (startTimeDiff < nearestStartTimeDiff && startTimeDiff > 0) {
          nearestStartTimeIndex = index;
          nearestStartTimeDiff = startTimeDiff;
        }
      }
    });

    // Step 3: Move the provider with the nearest future time slot to the front
    if (nearestStartTimeIndex !== -1) {
      const nearestStartTimeCareAdvisor = sortedCareAdvisors.splice(nearestStartTimeIndex, 1)[0];
      sortedCareAdvisors.unshift(nearestStartTimeCareAdvisor);
    }

    // Step 4: Add `nextAvailable` to the first time slot of the first provider in the sorted list
    return sortedCareAdvisors.map((provider, index) => {
      const isNextAvailableCareAdvisor = index === 0 && !nextAvailableSet;

      if (isNextAvailableCareAdvisor) {
        nextAvailableSet = true;
      }

      const modifiedTimeSlots = provider.sync_time_intervals.map((slot, slotIndex) => ({
        ...slot,
        nextAvailable: isNextAvailableCareAdvisor && slotIndex === 0, // Mark only the first slot as `nextAvailable`
      }));

      return {
        ...provider,
        timeSlots: modifiedTimeSlots,
        allSlots: provider.sync_time_slots, // Retain all original time slots
      };
    });
  }, [providers]);

  const fetchLanguageOptions = async (): Promise<void> => {
    const data = await listAllLanguages();
    const transformedData = data.map((language) => ({
      value: language.locale,
      label: language.name,
      id: language.id,
    }));
    setLanguageOptions(transformedData);
  };

  useEffect(() => {
    (async (): Promise<void> => {
      await fetchLanguageOptions();

      const getPricingsFn = async (): Promise<void> => {
        try {
          const pricings = await getPricings();
          dispatch(setOrganizationPrices({ currentOrganizationPrices: pricings }));
        } catch (error: unknown) {
          displayErrorDetails(error);
        }
      };

      if (!organizationPrices?.currentOrganizationPrices) {
        await getPricingsFn();
      }
    })();
  }, []);

  const onSubmit = async (): Promise<void> => {
    if (selectedTimeSlot.selectedTimeSlot) {
      if (RescheduleCase && state?.caseId) {
        let updatedCase;
        try {
          setLoading(true);

          const payload: RescheduleCasePayload = {
            video_conference_date: convertDateFormat(selectedTimeSlot.selectedDateTime as string),
            clinician_id: selectedTimeSlot.selectedCareAdvisorId,
            case_type: CaseType.oral_health_coaching,
          };
          updatedCase = await rescheduleCase(state?.caseId, payload);

          setRescheduleSuccessModal({
            openModal: true,
            updatedCase: updatedCase as ICase,
          });
          setLoading(false);
        } catch (error: unknown) {
          displayErrorDetails(error);
        }
      } else {
        const filteredPayload = values.filter((item) => item.form_question_id !== 14 && item.form_question_id !== 22);

        filteredPayload.push(
          {
            form_question_id: 14,
            value: {
              selectedTimeSlot: selectedTimeSlot.selectedDateTime as string,
              ...(caseType !== CaseType.oral_health_coaching && {
                selectedCareAdvisorId: selectedTimeSlot.selectedCareAdvisorId,
              }),
              ...(caseType === CaseType.oral_health_coaching && {
                selectedCareAdvisorId: selectedTimeSlot.selectedCareAdvisorId,
              }),
            },
          },
          {
            form_question_id: 22,
            value: {
              selectedLanguagesForCareAdvisor: languageFilter,
            },
          },
        );
        dispatch(setForm(filteredPayload));

        const currentOrganizationPrice = currentOrganizationPrices?.find((price: Pricings) =>
          price.case_types.includes(values.find((item) => item.form_question_id === 20)?.value.caseType as string),
        );

        const q19Value = values.find((item) => item.form_question_id === 19)?.value as
          | Record<string, unknown>
          | undefined;

        if (isStaffPatientFlow && isIntakePaymentQuestionComplete(q19Value)) {
          roleNavigate('/confirm-payment');
        } else if (needsPayment(currentOrganizationPrice)) {
          roleNavigate('/payment-information');
        } else {
          roleNavigate('/confirm-payment');
        }
      }
    } else {
      roleNavigate('/select-care-advisor-details', {
        state: {
          caseType,
          patientId: selectedPatient?.value,
          care_advisor_id: selectedTimeSlot.selectedCareAdvisorId,
          RescheduleCase: state?.RescheduleCase,
          caseId: state?.caseId,
        },
      });
    }
  };

  const handleTimeSlotClick = (date: string, slot: string, care_advisor_id: number): void => {
    const currentTime = Moment(); // Get the current time
    const startTimeMoment = Moment(slot);
    const isCurrentDate = startTimeMoment.isSame(moment(), 'day');

    if (isCurrentDate) {
      const isPast = startTimeMoment.isBefore(currentTime);
      if (isPast) {
        toast.error('The time slot you selected is in the past. Please select a different time slot.', {
          className: 'fs-unmask',
        });
        return;
      }
    }

    if ((startTimeMoment.diff(currentTime, 'minutes') >= 30 && isCurrentDate) || !isCurrentDate) {
      const formattedForDisplay = startTimeMoment.format('dddd, MMMM D, YYYY h:mm a'); // 👈 For storing in Redux
      const formattedForSubmission = formatTime(startTimeMoment.toDate());
      setSelectedTimeSlot({
        selectedDate: date,
        selectedTimeSlot: formattedForSubmission,
        selectedDateTime: formattedForDisplay,
        selectedCareAdvisorId: care_advisor_id,
      });
    } else {
      toast.error('The time slot you selected is no longer available. Please select a different time slot.', {
        className: 'fs-unmask',
      });
      refreshCareAdvisors();
      setSelectedTimeSlot({
        selectedDate: '',
        selectedTimeSlot: '',
        selectedDateTime: '',
        selectedCareAdvisorId: undefined,
      });
    }
  };

  useEffect(() => {
    const selectedSlotFormItem = values.find((item) => item.form_question_id === 14);
    const selectedLanguagesForCareAdvisor = values.find((item) => item.form_question_id === 22);

    const value = selectedSlotFormItem?.value;
    const selectedLanguages =
      (selectedLanguagesForCareAdvisor?.value?.selectedLanguagesForCareAdvisor as MultiValue<Option>) || [];

    if (selectedLanguages.length > 0) {
      setLanguageFilter(selectedLanguages);
    }

    if (value && typeof value.selectedTimeSlot === 'string' && typeof value.selectedCareAdvisorId === 'number') {
      const storedDateTime = value.selectedTimeSlot;
      const providerId = value.selectedCareAdvisorId;

      const dateTimeMoment = moment(storedDateTime, 'dddd, MMMM D, YYYY h:mm a');
      const formattedTime = formatTime(dateTimeMoment.toDate());
      const formattedDate = dateTimeMoment.format('YYYY-MM-DD');

      setSelectedTimeSlot({
        selectedDate: formattedDate,
        selectedTimeSlot: formattedTime,
        selectedDateTime: storedDateTime,
        selectedCareAdvisorId: providerId,
      });
    }
  }, [values]);

  if (loading) {
    return <Loading dotted />;
  }

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{
        zIndex: '2',
        paddingTop: '24px',
        paddingBottom: '0px',
      }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.providerSelectContainer}`}>
        <PatientIntakeNavigation progress={8} />
        <form className={`${styles.formContainer}`}>
          <div className={styles.providerSelectWrapper}>
            <div className={styles.providerSelectTitleContainer}>
              <div className={styles.providerSelectTitle} data-testid="select-provider-title">
                Select an oral health coach and time{screenSize.width >= 768 ? '' : ' slot'}
              </div>
              {screenSize.width >= 768 && (
                <div className={styles.providerSelectSubtitle} data-testid="select-provider-time-zone">
                  Times are in {timezone}
                </div>
              )}
            </div>
            <div className={styles.providerSelectFilter}>
              <div className={styles.filterGroup}>
                <LanguageMultiSelect
                  data-testid="select-provider-select-language"
                  selectedLanguages={languageFilter}
                  setSelectedLanguages={setLanguageFilter}
                  languageOptions={languageOptions}
                />
              </div>
            </div>

            <div className={styles.providerSelectList}>
              {dataLoading ? (
                <div className={styles.loadingMore}>
                  <span>Loading more care advisors...</span>
                </div>
              ) : sortedCareAdvisorsWithTimeSlots.length > 0 ? (
                sortedCareAdvisorsWithTimeSlots.map((provider, index) => (
                  <div
                    key={provider.id}
                    ref={index === sortedCareAdvisorsWithTimeSlots.length - 1 ? lastCareAdvisorItemRef : null}
                  >
                    <div className={styles.providerSelectListItem}>
                      <div className={styles.providerSelectListItemDetails}>
                        <div
                          className={styles.imageContainer}
                          onClick={() => {
                            setCareAdvisorParticipant(provider.user);
                            setCareAdvisorProfileCardModal(true);
                          }}
                        >
                          <img
                            alt="Avatar"
                            className={`fs-exclude ${styles.providerImage}`}
                            src={getUserAvatar(provider?.id || 0)}
                            onError={(e) => {
                              e.currentTarget.src = '/assets/images/default-avatar.svg';
                            }}
                          />
                        </div>

                        <div className={styles.providerSelectListItemDetailsTextContainer}>
                          <div className={styles.providerSelectListItemDetailsText}>
                            <div
                              className={`fs-exclude ${styles.providerName}`}
                              onClick={() => {
                                setCareAdvisorParticipant(provider.user);
                                setCareAdvisorProfileCardModal(true);
                              }}
                              data-testid="select-provider-name"
                            >
                              {provider.user.full_name}
                            </div>

                            <div className={styles.providerLanguages}>
                              <span className={styles.providerLanguagesLabel}>Languages: </span>
                              <span className={styles.providerLanguagesList}>
                                {provider.user?.basic_info?.languages?.length
                                  ? provider.user.basic_info.languages.map((lang) => lang?.name).join(', ')
                                  : 'No languages available'}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles.providerSelectListItemTimeSlots}>
                        {(() => {
                          const firstSlot = provider.allSlots?.[0];
                          if (!firstSlot) return null;

                          const slotMoment = Moment(firstSlot);
                          const today = Moment().startOf('day');
                          const tomorrow = Moment().add(1, 'day').startOf('day');

                          const isToday = slotMoment.isSame(today, 'day');
                          const isTomorrow = slotMoment.isSame(tomorrow, 'day');

                          const formattedDateForState = slotMoment.format('YYYY-MM-DD');

                          const formattedDate = slotMoment.format('dddd, MMM D'); // e.g. Saturday, Nov 23

                          return (
                            <>
                              <div
                                className={styles.providerSelectListItemTimeSlotsLabel}
                                data-testid="select-provider-date"
                              >
                                {isToday && <span style={{ fontWeight: '700' }}>Today </span>}
                                {isTomorrow && !isToday && <span style={{ fontWeight: '700' }}>Tomorrow </span>}
                                <span>{formattedDate}</span>
                              </div>

                              <div
                                className={styles.providerSelectListItemTimeSlotContainer}
                                data-testid="select-provider-select-buttons"
                              >
                                {(() => {
                                  const firstSlotDay = slotMoment.startOf('day');
                                  const sameDaySlots = provider.allSlots.filter((slot) =>
                                    Moment(slot).startOf('day').isSame(firstSlotDay),
                                  );
                                  const displaySlots = sameDaySlots.slice(0, 3);
                                  const isNextAvailable = provider.timeSlots?.some((t) => t.nextAvailable);

                                  return displaySlots.map((slot, i) => {
                                    const matching = provider.timeSlots.find((t) => t.start_time === slot);
                                    const nextAvailable = isNextAvailable && matching?.nextAvailable;

                                    return (
                                      <Button
                                        key={i}
                                        onClick={() =>
                                          handleTimeSlotClick(firstSlotDay.format('YYYY-MM-DD'), slot, provider.id)
                                        }
                                        color="primary"
                                        variant="outlined"
                                        data-testid={`select-provider-date-button-${i}`}
                                        className={`${styles.providerSelectListItemTimeSlot} 
                                        
                                        ${nextAvailable ? styles.nextAvailable : ''} 
                                        ${
                                          selectedTimeSlot.selectedTimeSlot === formatTime(Moment(slot).toDate()) &&
                                          selectedTimeSlot.selectedCareAdvisorId === provider.id
                                            ? styles.selectedTimeSlot
                                            : ''
                                        }`}
                                      >
                                        {formatTime(Moment(slot).toDate())}
                                      </Button>
                                    );
                                  });
                                })()}
                              </div>

                              <div
                                className={styles.providerSelectListItemTimeSlotsMore}
                                onClick={() => {
                                  const existingValue = values.find((item) => item.form_question_id === 14)?.value;
                                  dispatch(
                                    setForm([
                                      ...values.filter((item) => item.form_question_id !== 14),
                                      {
                                        form_question_id: 14,
                                        value: {
                                          ...existingValue,
                                          selectedCareAdvisor: provider,
                                        },
                                      },
                                    ]),
                                  );
                                  roleNavigate('/select-care-advisor-details', {
                                    state: {
                                      provider_details: provider,
                                      date: formattedDateForState,
                                      RescheduleCase: state?.RescheduleCase,
                                      caseId: state?.caseId,
                                    },
                                  });
                                }}
                              >
                                <span data-testid="select-provider-select-all-availability">See all availability</span>
                              </div>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className={styles.noProviders}>
                  <div className={styles.noProvidersText}>Sorry, we currently don’t have care advisors.</div>
                </div>
              )}
              {isLoading && (
                <div className={styles.loadingMore}>
                  <span>Loading more...</span>
                </div>
              )}
            </div>
            {sortedCareAdvisorsWithTimeSlots.length === 0 && !dataLoading && (
              <div className={styles.noProviders}>
                <span className={styles.noProvidersText}>No care advisors available for the selected filters</span>
              </div>
            )}

            <div className={styles.providerSelectFooter}>
              <button
                type="button"
                data-testid="select-provider-button-back"
                className={styles.providerSelectFooterBackButton}
                onClick={() => roleNavigate(backPath)}
              >
                <FaChevronLeft />
                Back
              </button>
              <button
                type="submit"
                className={styles.providerSelectFooterNextButton}
                data-testid="select-provider-button-next"
                onClick={(e) => {
                  e.preventDefault();
                  onSubmit();
                }}
                disabled={
                  (caseType === CaseType.oral_health_coaching && !selectedTimeSlot.selectedCareAdvisorId) ||
                  (!selectedTimeSlot.selectedDate && !selectedTimeSlot.selectedTimeSlot)
                }
              >
                {`${RescheduleCase ? 'Reschedule' : 'Next'} `}
              </button>
            </div>
          </div>
        </form>
        {providerProfileCardModal && (
          <CareAdvisorProfileCardModal
            isOpen={providerProfileCardModal}
            toggleModal={setCareAdvisorProfileCardModal}
            caIdentity={providerParticipant}
          />
        )}
        {rescheduleSuccessModal.openModal && (
          <ScheduleLiveConsultation newCase={rescheduleSuccessModal.updatedCase as ICase} isRescheduled />
        )}
      </div>
    </Container>
  );
};
export default SelectCareAdvisor;
